const lightningsMugcsiSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="86.793px" height="123.99px" viewBox="0 0 86.793 123.99" enable-background="new 0 0 86.793 123.99" xml:space="preserve">
<g id="Layer_1">
	<g>
		<g>
			<g>
				<path fill="#1CADE3" d="M62.508,83.814c2.072-3.781,3.21-8.304,3.21-13.313c0,0-0.097-27.14-0.241-27.446
					c-0.447-3.303-3.144-5.639-6.5-5.639c-3.676,0-6.697,2.616-6.864,6.226c-0.028,0.165-0.51,27.32-0.51,27.32
					c0,7.24-3.573,12.173-10.352,12.173s-10.567-4.933-10.567-12.173c0,0,0.015-27.587-0.124-27.889
					c-0.441-3.311-3.085-5.657-6.447-5.657c-3.627,0-6.569,2.552-6.801,6.085c-0.046,0.204-0.481,27-0.481,27
					c0,5.116,1.601,9.723,3.756,13.553C12.991,86.875,8.4,94.322,8.4,103.234c0,11.912,8.822,20.756,20.863,20.756h24.842
					c12.04,0,20.659-8.973,20.659-21.01C74.764,94.221,70.011,86.803,62.508,83.814z"/>
				<g>
					<path fill="#FFFFFF" d="M64.896,102.185c0,5.988-4.855,10.84-10.839,10.84H29.235c-5.985,0-10.84-4.852-10.84-10.84l0,0
						c0-5.988,4.855-10.841,10.84-10.841h24.822C60.042,91.344,64.896,96.196,64.896,102.185L64.896,102.185z"/>
					<path fill="#231F20" d="M30.399,102.965c0,1.624-1.321,2.945-2.946,2.945l0,0c-1.628,0-2.949-1.321-2.949-2.945v-3.25
						c0-1.626,1.321-2.947,2.949-2.947l0,0c1.625,0,2.946,1.321,2.946,2.947V102.965z"/>
					<path fill="#231F20" d="M59.254,102.76c0,1.626-1.321,2.948-2.949,2.948l0,0c-1.628,0-2.947-1.322-2.947-2.948v-3.249
						c0-1.625,1.319-2.945,2.947-2.945l0,0c1.628,0,2.949,1.32,2.949,2.945V102.76z"/>
				</g>
			</g>
		</g>
		<polygon fill="#08FCC9" points="16.15,25.84 9.69,25.84 12.92,14.535 0,32.301 6.461,32.301 3.23,43.606 		"/>
		<polygon fill="#08FCC9" points="47.492,11.305 41.032,11.305 44.261,0 31.341,17.766 37.802,17.766 34.572,29.071 		"/>
		<polygon fill="#08FCC9" points="86.793,29.11 80.333,29.11 83.563,17.806 70.643,35.571 77.104,35.571 73.874,46.877 		"/>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids" display="none">
</g>
</svg>

`;

export default lightningsMugcsiSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/lightnignsMugicsSVG.js